import { RootState } from '@store';

export const selectCustomerType = (state: RootState) => {
  return state.customer?.type;
};
